module.exports = __webpack_public_path__ + "static/media/innlink_logo_login_page.0b7972c3.svg";